<!-- eslint-disable vue/no-parsing-error -->
<template>
    <b-card-code>
        <div class="form-group">
            <label for="">Logo:</label><br>
            <b-form-file id="file" ref="file" @change="changeImage" />
            <div class="mt-25" v-if="imageUrl">
                <b-img height="100" :src="imageUrl" rounded :alt="`Preview Image ${formPayload.name}`"
                    class="d-inline-block mr-25 border" />
            </div>
            <div class="alert alert-info p-1 mt-1">
                <strong>Catatan</strong>
                <ul>
                    <li>Maksimal ukuran file adalah 1MB</li>
                </ul>
            </div>
        </div>

        <div class="form-group">
            <label for="">Website Favicon:</label><br>
            <b-form-file id="file-favicon" ref="file-favicon" @change="changeFavicon" />
            <div class="mt-25" v-if="previewFavicon">
                <b-img height="100" :src="previewFavicon" rounded alt="favicon" class="d-inline-block mr-25 border" />
            </div>
        </div>

        <!-- Name -->
        <FormInput :id="'name'" :label="'Name'" v-model="formPayload.name" :validation="validations.name"
            :placeholder="'Name'" :required="true" :type="'text'" :modelValue="formPayload.name" />

        <!-- Address -->
        <FormTextarea :id="'address'" :label="'Address'" v-model="formPayload.address" :validation="validations.address"
            :placeholder="'Address'" :required="false" :modelValue="formPayload.address" :rows="3" />

        <!-- Facebook -->
        <FormInput :id="'facebook'" :label="'Facebook'" v-model="formPayload.facebook"
            :validation="validations.facebook" :placeholder="'Facebook'" :required="false" :type="'text'"
            :modelValue="formPayload.facebook" />

        <!-- Twitter -->
        <FormInput :id="'twitter'" :label="'Twitter'" v-model="formPayload.twitter" :validation="validations.twitter"
            :placeholder="'Twitter'" :required="false" :type="'text'" :modelValue="formPayload.twitter" />

        <!-- Instagram -->
        <FormInput :id="'instagram'" :label="'Instagram'" v-model="formPayload.instagram"
            :validation="validations.instagram" :placeholder="'Instagram'" :required="false" :type="'text'"
            :modelValue="formPayload.instagram" />

        <!-- Youtube -->
        <FormInput :id="'youtube'" :label="'Youtube'" v-model="formPayload.youtube" :validation="validations.youtube"
            :placeholder="'Youtube'" :required="false" :type="'text'" :modelValue="formPayload.youtube" />

        <!-- Tiktok -->
        <FormInput :id="'tiktok'" :label="'Tiktok'" v-model="formPayload.tiktok" :validation="validations.tiktok"
            :placeholder="'Tiktok'" :required="false" :type="'text'" :modelValue="formPayload.tiktok" />

        <!-- Website Title -->
        <FormInput :id="'website_title'" :label="'Website Title'" v-model="formPayload.website_title"
            :validation="validations.website_title" :placeholder="'Website Title'" :required="false" :type="'text'"
            :modelValue="formPayload.website_title" />

        <!-- Website Name -->
        <FormInput :id="'website_name'" :label="'Website Name'" v-model="formPayload.website_name"
            :validation="validations.website_name" :placeholder="'Website Name'" :required="false" :type="'text'"
            :modelValue="formPayload.website_name" />

        <!-- Website Description -->
        <FormTextarea :id="'website_description'" :label="'Website Description'"
            v-model="formPayload.website_description" :validation="validations.website_description"
            :placeholder="'Website Description'" :required="false" :modelValue="formPayload.website_description"
            :rows="3" />

        <div class="form-group">
            <label for="website_theme">Website Theme:</label>
            <b-form-select id="website_theme" v-model="formPayload.website_theme" :options="options" />
            <div class="mt-1" v-if="formPayload.website_theme != '' && palettesFilter">
                <div class="d-flex align-items-center">
                    <p class="mr-1 mb-0">Color Palette: </p>
                    <b-img v-for="palette, index in palettesFilter.palettes" :key="index" v-bind="mainProps"
                        :blank-color="palette" rounded :alt="`HEX shorthand color image (${palette})`"
                        class="d-inline-block mr-25 border" />
                </div>
            </div>
            <small v-if="validations.hasOwnProperty('website_theme') && validations.website_theme.length > 0"
                class="text-danger">
                {{ validations.website_theme.join(', ') }}
            </small>
        </div>

        <div class="form-group">
            <label for="website_keywords">Website Keywords:</label>
            <b-form-tags id="website_keywords" v-model="formPayload.website_keywords" input-id="tags-website-keywords"
                class="mb-2" placeholder="Add website keywords" />
            <small v-if="validations.hasOwnProperty('website_keywords') && validations.website_keywords.length > 0"
                class="text-danger">
                {{ validations.website_keywords.join(', ') }}
            </small>
        </div>

        <!-- Google Property ID -->
        <FormInput :id="'website_google_property_id'" :label="'Google Property ID'" v-model="formPayload.website_google_property_id"
                 :validation="validations.website_google_property_id" :placeholder="'Google Property ID'" :required="false" :type="'text'"
                 :modelValue="formPayload.website_google_property_id" :helperLinkText="'How To Get Google Property ID'" :isHelperLink="true" :helperLinkHref="'https://developers.google.com/analytics/devguides/reporting/data/v1/property-id'" />

        <!-- Google Ads Txt -->
        <FormTextarea :id="'google_ads_txt'" :label="'Google Ads Txt'"
            v-model="formPayload.google_ads_txt" :validation="validations.google_ads_txt"
            :placeholder="'Google Ads Txt'" :required="false" :modelValue="formPayload.google_ads_txt"
            :rows="3" />

        <!-- Google Publisher Tag Code -->
        <FormTextarea :id="'google_publisher_tag_code'" :label="'Google Publisher Tag Code'"
            v-model="formPayload.google_publisher_tag_code" :validation="validations.google_publisher_tag_code"
            :placeholder="'Google Publisher Tag Code'" :required="false" :modelValue="formPayload.google_publisher_tag_code"
            :rows="3" />
        <a href="https://support.google.com/admanager/answer/177207?hl=en" class="text-primary " target="_blank" style="font-size: 12px;">
            How To Get GPT
        </a>
        
        <div>
            <div>
                <b-form ref="form" class="repeater-form" @submit.prevent="repeateAgain">

                    <!-- Row Loop -->
                    <b-row v-for="(item, index) in items" :id="item.id" :key="item.id" ref="row">

                        <!-- Email -->
                        <b-col md="5">
                            <b-form-group label="Email" :label-for="`emails-${item.id}`">
                                <b-form-input :id="`emails-${item.id}`" v-model="items[index].emails" type="text"
                                    placeholder="Email" />
                            </b-form-group>
                        </b-col>

                        <!-- Phone Number -->
                        <b-col md="4">
                            <b-form-group label="Phone Number" :label-for="`phones-${item.id}`">
                                <b-form-input :id="`phones-${item.id}`" v-model="items[index].phone_numbers" type="tel"
                                    placeholder="Phone Number" />
                            </b-form-group>
                        </b-col>

                        <!-- Remove Button -->
                        <b-col lg="3" md="4" class="mb-50">
                            <b-button :id="`delete-${item.id}`" v-ripple.400="'rgba(234, 84, 85, 0.15)'"
                                variant="outline-danger" class="mt-0 mt-md-2" @click="removeItem(index)">
                                <feather-icon icon="XIcon" class="mr-25" />
                                <span>Delete</span>
                            </b-button>
                        </b-col>
                        <b-col cols="12">
                            <hr>
                        </b-col>
                    </b-row>

                </b-form>
            </div>
        </div>

        <!-- Google Tag Manager -->
        <div>
            <div>
                <b-form ref="form" class="repeater-form" @submit.prevent="repeateFormGoogleTagManagerIds">

                    <!-- Row Loop -->
                    <b-row v-for="(item, index) in itemGoogleTagManagerIds" :id="item.id" :key="item.id" ref="row">

                        <!-- Google Tag -->
                        <b-col md="9">
                            <b-form-group label="Website GTM ID" :label-for="`website_google_tag_manager_id-${item.id}`" class="mb-0">
                                <b-form-input :id="`website_google_tag_manager_id-${item.id}`"
                                    v-model="itemGoogleTagManagerIds[index].website_google_tag_manager_ids"
                                    placeholder="GTM-XXXXX" />
                            </b-form-group>
                            <a href="https://support.google.com/tagmanager/answer/14847097?sjid=17040454136797633950-NC" class="text-primary " target="_blank" style="font-size: 12px;">
                                How To Get GTM ID
                            </a>
                        </b-col>

                        <!-- Remove Button -->
                        <b-col md="3" class="mb-50">
                            <b-button :id="`delete-${item.id}`" v-ripple.400="'rgba(234, 84, 85, 0.15)'"
                                variant="outline-danger" class="mt-0 mt-md-2" @click="removeItemGoogleTagManagerIds(index)">
                                <feather-icon icon="XIcon" class="mr-25" />
                                <span>Delete</span>
                            </b-button>
                        </b-col>
                        <b-col cols="12">
                            <hr>
                        </b-col>
                    </b-row>

                </b-form>
            </div>
        </div>

        <!-- Google Tag -->
        <div>
            <div>
                <b-form ref="form" class="repeater-form" @submit.prevent="repeateFormGoogleTagIds">

                    <!-- Row Loop -->
                    <b-row v-for="(item, index) in itemGoogleTagIds" :id="item.id" :key="item.id" ref="row">

                        <!-- Google Tag -->
                        <b-col md="9">
                            <b-form-group label="Website GA4 Tag Id" :label-for="`website_google_tag_id-${item.id}`" class="mb-0">
                                <b-form-input :id="`website_google_tag_id-${item.id}`"
                                    v-model="itemGoogleTagIds[index].website_google_tag_ids"
                                    placeholder="G-LPQWEZCSA" />
                            </b-form-group>
                            <a href="https://support.google.com/analytics/answer/9539598" class="text-primary " target="_blank" style="font-size: 12px;">
                                How To Get GA4 Tag Id
                            </a>
                        </b-col>

                        <!-- Remove Button -->
                        <b-col md="3" class="mb-50">
                            <b-button :id="`delete-${item.id}`" v-ripple.400="'rgba(234, 84, 85, 0.15)'"
                                variant="outline-danger" class="mt-0 mt-md-2" @click="removeItemGoogleTagIds(index)">
                                <feather-icon icon="XIcon" class="mr-25" />
                                <span>Delete</span>
                            </b-button>
                        </b-col>
                        <b-col cols="12">
                            <hr>
                        </b-col>
                    </b-row>

                </b-form>
            </div>
        </div>

        <!-- Google Ads -->
        <div>
            <div>
                <b-form ref="form" class="repeater-form" @submit.prevent="repeateFormGoogleAdsIds">

                    <!-- Row Loop -->
                    <b-row v-for="(item, index) in itemGoogleAdsIds" :id="item.id" :key="item.id" ref="row">

                        <!-- Google Ads -->
                        <b-col md="9">
                            <b-form-group label="Website Google Ads Id"
                                :label-for="`website_google_ads_ids-${item.id}`" class="mb-0">
                                <b-form-input :id="`website_google_ads_ids-${item.id}`"
                                    v-model="itemGoogleAdsIds[index].website_google_ads_ids"
                                    placeholder="ca-pub-12332432543" />
                            </b-form-group>
                            <a href="https://support.google.com/adsense/answer/105516?hl=en" class="text-primary " target="_blank" style="font-size: 12px;">
                                How To Get Google Ads Id
                            </a>
                        </b-col>

                        <!-- Remove Button -->
                        <b-col md="3" class="mb-50">
                            <b-button :id="`delete-${item.id}`" v-ripple.400="'rgba(234, 84, 85, 0.15)'"
                                variant="outline-danger" class="mt-0 mt-md-2" @click="removeItemGoogleAdsIds(index)">
                                <feather-icon icon="XIcon" class="mr-25" />
                                <span>Delete</span>
                            </b-button>
                        </b-col>
                        <b-col cols="12">
                            <hr>
                        </b-col>
                    </b-row>

                </b-form>
            </div>
        </div>

        <template>
            <b-button id="add-new" class="mr-1" v-ripple.400="'rgba(255, 255, 255, 0.15)'" variant="primary"
                @click="repeateAgain">
                <feather-icon icon="PlusIcon" class="mr-25" />
                <span>Add New Email and Phone</span>
            </b-button>
            <b-button id="add-new" class="mr-1" v-ripple.400="'rgba(255, 255, 255, 0.15)'" variant="primary"
                @click="repeateFormGoogleTagManagerIds">
                <feather-icon icon="PlusIcon" class="mr-25" />
                <span>Add GTM ID</span>
            </b-button>
            <b-button id="add-new" class="mr-1" v-ripple.400="'rgba(255, 255, 255, 0.15)'" variant="primary"
                @click="repeateFormGoogleTagIds">
                <feather-icon icon="PlusIcon" class="mr-25" />
                <span>Add GA4 Tag Id</span>
            </b-button>
            <b-button id="add-new" class="mr-1" v-ripple.400="'rgba(255, 255, 255, 0.15)'" variant="primary"
                @click="repeateFormGoogleAdsIds">
                <feather-icon icon="PlusIcon" class="mr-25" />
                <span>Add Google Ads Id</span>
            </b-button>
            <div v-if="isLoading" class="mb-1">
                <b-spinner class="mb-2" variant="primary" /><br>
            </div>
            <b-button id="save-item" v-else variant="success" :disabled="isLoading" @click="updateItem()">
                Save Item
            </b-button>
        </template>
    </b-card-code>
</template>

<script>
import BCardCode from '@core/components/b-card-code/BCardCode.vue'
import {
    BCard, BCardText, BButton, BDropdown, BDropdownItem, BSpinner,
    BFormGroup, BTabs, BTab, BNavItem, BPagination, BFormInput, BFormFile, BRow, BCol, BForm, BFormTextarea, BImg, BFormSelect, BFormTags,
} from 'bootstrap-vue'
import { heightTransition } from '@core/mixins/ui/transition'
import Ripple from 'vue-ripple-directive'

import { successNotification, errorNotification } from '@/auth/utils'
import { optionsSelectTheme } from '@/utils/website_theme'
import FormRepeaterItem from '@/components/FormRepeaterItem.vue'
import FormTextarea from '@/components/FormTextarea.vue'
import FormInput from '@/components/FormInput.vue'

export default {
    title() {
        return 'Settings'
    },
    components: {
        BFormGroup,
        BCard,
        BButton,
        BCardText,
        BCardCode,
        BDropdown,
        BDropdownItem,
        BTabs,
        BTab,
        BNavItem,
        BSpinner,
        BPagination,
        BFormInput,
        BFormFile,
        BRow,
        BCol,
        BForm,
        BFormTextarea,
        BImg,
        BFormSelect,
        BFormTags,
        FormRepeaterItem,
        FormTextarea,
        FormInput,
    },
    directives: {
        Ripple,
    },
    setup() {
        return { successNotification, errorNotification }
    },
    mixins: [heightTransition],
    watch: {
    },
    computed: {
        palettesFilter() {
            return this.options.find(item => item.value === this.formPayload.website_theme);
        }
    },
    data() {
        const userData = JSON.parse(localStorage.getItem('userData'))
        return {
            userData,
            // Form Repeater
            items: [{
                id: 1,
                emails: '',
                phone_numbers: '',
            }],
            itemGoogleTagIds: [{
                id: 1,
                website_google_tag_ids: '',
            }],
            itemGoogleAdsIds: [{
                id: 1,
                website_google_ads_ids: '',
            }],
            itemGoogleTagManagerIds: [{
                id: 1,
                website_google_tag_manager_ids: '',
            }],
            nextItemsId: 2,
            nextItemGoogleTagIds: 2,
            nextItemGoogleAdsIds: 2,
            nextItemGoogleTagManagerIds: 2,

            isLoading: false,
            formPayload: {
                name: '',
                address: '',
                facebook: '',
                twitter: '',
                instagram: '',
                youtube: '',
                tiktok: '',
                logo: '',
                website_description: '',
                website_name: '',
                website_title: '',
                website_theme: '',
                website_keywords: [],
                website_favicon: null,
                google_publisher_tag_code: '',
            },
            imageUrl: null,
            mainProps: {
                blank: true,
                width: 25,
                height: 25,
            },
            validations: {},
            options: optionsSelectTheme,
            previewFavicon: null
        }
    },
    mounted() {
        if (this.userData) {
            this.editItem(this.userData)
        }
    },
    created() {
    },
    destroyed() {
    },
    methods: {
        // Form Repeat
        repeateAgain() {
            this.items.push({
                id: this.nextItemsId += this.nextItemsId,
            })
        },
        repeateFormGoogleTagIds() {
            this.itemGoogleTagIds.push({
                id: this.nextItemGoogleTagIds += this.nextItemGoogleTagIds,
            })
        },
        repeateFormGoogleAdsIds() {
            this.itemGoogleAdsIds.push({
                id: this.nextItemGoogleAdsIds += this.nextItemGoogleAdsIds,
            })
        },
        repeateFormGoogleTagManagerIds() {
            this.itemGoogleTagManagerIds.push({
                id: this.nextItemGoogleTagManagerIds += this.nextItemGoogleTagManagerIds,
            })
        },
        removeItem(index) {
            this.items.splice(index, 1)
        },
        removeItemGoogleTagIds(index) {
            this.itemGoogleTagIds.splice(index, 1)
        },
        removeItemGoogleAdsIds(index) {
            this.itemGoogleAdsIds.splice(index, 1)
        },
        removeItemGoogleTagManagerIds(index) {
            this.itemGoogleTagManagerIds.splice(index, 1)
        },
        // End Form Repeat

        async changeImage(event) {
            try {
                const files = event.target.files[0]
                this.formPayload.logo = files
            } catch (error) {
                console.log(error);
            }
        },
        changeFavicon(event) {
            try {
                const fileInput = event.target;
                const file = event.target.files[0];
                if (!file) return;

                // Check if the file has a .ico extension
                const fileName = file.name.toLowerCase();
                if (!fileName.endsWith('.ico')) {
                    errorNotification(this, 'Oops!', 'Please upload a file with a .ico extension');
                    fileInput.value = '';
                    return;
                }

                const fileURL = URL.createObjectURL(file);
                this.previewFavicon = fileURL;
                this.formPayload.website_favicon = file;
            } catch (error) {
                console.log(error);
            }
        },
        cleanUpForm() {
            this.editId = null
            this.formPayload = {
                name: '',
                address: '',
                facebook: '',
                twitter: '',
                instagram: '',
                youtube: '',
                tiktok: '',
                logo: '',
                website_theme: '',
            }
            this.items = [{
                id: 1,
                emails: '',
                phone_numbers: '',
            }]
            this.itemGoogleTagIds = [{
                id: 1,
                website_google_tag_ids: '',
            }]
            this.itemGoogleAdsIds = [{
                id: 1,
                website_google_ads_ids: '',
            }]
            this.itemGoogleTagManagerIds = [{
                id: 1,
                website_google_tag_manager_ids: '',
            }]
        },
        updateItem() {
            const form = this.preparePayload()

            this.$http.patch(`/admin/partners/${this.userData.partner._id}`, form, {
                headers: { 'content-type': 'multipart/form-data' },
            })
                .then(response => {
                    this.editItem(this.userData)
                    successNotification(this, 'Success', 'Data successfully updated!')
                })
                .catch(error => {
                    const validations = error.response.data.meta.validations
                    const messages = error.response.data.meta.messages
                    // this.validations = validations
                    if (validations) {
                        for (const key in validations) {
                            if (validations.hasOwnProperty(key)) {
                                errorNotification(this, 'Oops!', key + ' ' + validations[key].join(', '))
                            }
                        }
                    }
                    if (messages) {
                        errorNotification(this, 'Oops!', messages)
                    }
                })
        },
        preparePayload() {
            const form = new FormData()

            // eslint-disable-next-line no-restricted-syntax
            for (const key in this.formPayload) {
                if (this.formPayload.hasOwnProperty(key) && this.formPayload[key] != null && this.formPayload[key] != '') {
                    // Handle if this.formPayload[key] is array
                    if (key != 'website_theme' && key != 'website_keywords') {
                        form.append(key, this.formPayload[key])
                    }
                    if (key == 'website_theme') {
                        form.append(key, this.formPayload[key].toLowerCase())
                    }
                    if (key == 'website_keywords') {
                        if (Array.isArray(this.formPayload.website_keywords)) {
                            this.formPayload.website_keywords.forEach((element, index) => {
                                form.append(`${key}[${index}]`, element);
                            });
                        }
                    }
                }
            }

            if (this.items.length) {
                for (let index = 0; index < this.items.length; index++) {
                    const element = this.items[index]
                    for (const key in element) {
                        if (Object.hasOwnProperty.call(element, key) && element[key] != null && element[key] != '') {
                            const items = element[key]
                            if (['emails', 'phone_numbers'].includes(key)) {
                                form.append(`${key}[${index}]`, items)
                            }
                        }
                    }
                }
            }

            if (this.itemGoogleTagIds.length) {
                for (let index = 0; index < this.itemGoogleTagIds.length; index++) {
                    const element = this.itemGoogleTagIds[index]
                    for (const key in element) {
                        if (Object.hasOwnProperty.call(element, key) && element[key] != null && element[key] != '') {
                            const items = element[key]
                            if (['website_google_tag_ids'].includes(key)) {
                                form.append(`${key}[${index}]`, items)
                            }
                        }
                    }
                }
            }
            if (this.itemGoogleAdsIds.length) {
                for (let index = 0; index < this.itemGoogleAdsIds.length; index++) {
                    const element = this.itemGoogleAdsIds[index]
                    for (const key in element) {
                        if (Object.hasOwnProperty.call(element, key) && element[key] != null && element[key] != '') {
                            const items = element[key]
                            if (['website_google_ads_ids'].includes(key)) {
                                form.append(`${key}[${index}]`, items)
                            }
                        }
                    }
                }
            }
            if (this.itemGoogleTagManagerIds.length) {
                for (let index = 0; index < this.itemGoogleTagManagerIds.length; index++) {
                    const element = this.itemGoogleTagManagerIds[index]
                    for (const key in element) {
                        if (Object.hasOwnProperty.call(element, key) && element[key] != null && element[key] != '') {
                            const items = element[key]
                            if (['website_google_tag_manager_ids'].includes(key)) {
                                form.append(`${key}[${index}]`, items)
                            }
                        }
                    }
                }
            }

            return form
        },
        editItem(item) {
            this.$http.get(`admin/partners/${item.partner._id}`).then((result) => {
                const { name, address, facebook, twitter, instagram, youtube, tiktok, logo, website_theme, emails, phone_numbers, website_description, website_name, website_title, website_google_tag_ids, website_google_ads_ids, website_favicon, google_ads_txt, google_publisher_tag_code, 
                    website_google_tag_manager_ids } = result.data.data
                this.formPayload = {
                    name,
                    address,
                    facebook,
                    twitter,
                    instagram,
                    youtube,
                    tiktok,
                    website_description,
                    website_name,
                    website_title,
                    website_theme,
                    google_ads_txt,
                    google_publisher_tag_code,
                }

                this.imageUrl = logo
                this.previewFavicon = website_favicon

                this.items = emails.map((item, index) => {
                    return {
                        emails: item,
                        phone_numbers: phone_numbers[index]
                    }
                })
                this.itemGoogleTagIds = website_google_tag_ids.map((website_google_tag_ids) => {
                    return {
                        website_google_tag_ids
                    }
                })
                this.itemGoogleAdsIds = website_google_ads_ids.map((website_google_ads_ids) => {
                    return {
                        website_google_ads_ids
                    }
                })
                this.itemGoogleTagManagerIds = website_google_tag_manager_ids.map((website_google_tag_manager_ids) => {
                    return {
                        website_google_tag_manager_ids
                    }
                })

                console.log(itemGoogleTagManagerIds, 'itemGoogleTagManagerIds')
            }).catch((err) => {

            });

        },
        deleteItem(id) {
            this.$swal({
                title: 'Are you sure?',
                text: 'Are you sure to delete partner?',
                icon: 'warning',
                showCancelButton: true,
                customClass: {
                    confirmButton: 'btn btn-primary',
                    cancelButton: 'btn btn-outline-danger ml-1',
                },
                buttonsStyling: false,
            }).then(result => {
                if (result.value) {
                    this.$http.delete(`admin/partners/${id}`)
                        .then(response => {
                            this.getData(this.currentPage)
                            this.$swal({
                                icon: 'success',
                                title: 'Success!',
                                text: 'Partner successfully deleted',
                                customClass: {
                                    confirmButton: 'btn btn-success',
                                },
                            })
                        })
                        .catch(error => {
                            const validations = error.response.data.meta.validations
                            // this.validations = validations
                            for (const key in validations) {
                                if (validations.hasOwnProperty(key)) {
                                    errorNotification(this, 'Oops!', key + ' ' + validations[key].join(', '))
                                }
                            }
                        })
                }
            })
        },
    },
}
</script>

<style lang="scss">
.repeater-form {
    overflow: hidden;
    transition: .35s height;
}
</style>
